import { withCallToActionProps } from 'viewModel/productPage/callToAction/withCallToActionProps';
import CallToAction from 'components/ProductPage/CallToAction/CallToAction';

export default withCallToActionProps(CallToAction);
